$("input[name='owner_reason'], input[name='owner_lifestyle'], input[name='owner_reason']").on({
    change: function () {
        if(
            $("input[name='unit_owner']:checked").length > 0
            && $("input[name='owner_lifestyle']:checked").length > 0
            && $("input[name='owner_reason']:checked").length > 0
        ) {
            formFunctions.waitingForMatch();
        }
    }
});


$('.tab-linker-next:eq(0)').on({
    'click': function() {
        formFunctions.selectMatchingCompanies();
    }
});



var elemTarget = "";

$("#user_first, #user_last")
    .on('keyup change', function(){
        var $field = getFieldObject($(this).attr('id'));
        if ($(this).val().length >= 2) {
            $field.style('valid');
        } else if($(this).val().length < 2 && $field.getData('valid')) {
            $field.style('default');
        }
    })
    .on('blur', function(){
        var $field = getFieldObject($(this).attr('id'));

        if($(this).val().length <= 1) {
            $field.style('error');
        }
    });

email.field.on({
    mousedown: function () {
    },
    keydown: function (e) {
        clearTimeout(formFunctions.typingTimer);
        if (e.keyCode == 13 || e.which == 13) {
        }
        if(email.getData('valid') == "false") {
            email.style('default');
        }
    },
    focus: function () {
        email.style('default');
    },
    blur: function () {
        clearTimeout(formFunctions.typingTimer);
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if($(this).val().length <= 1) {
            email.style('error');
        }
        if(re.test($(this).val())) {
            formFunctions.typingTimer = setTimeout(function () {
                $("#email_check").val("ready").trigger('change');
                formFunctions.validateEmail(email.getVal());
            }, 1000);
        }
    },
    keyup: function () {
        clearTimeout(formFunctions.typingTimer);
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if(re.test($(this).val())) {
            formFunctions.typingTimer = setTimeout(function () {
                $("#email_check").val("ready").trigger('change');
                formFunctions.validateEmail(email.getVal());
            }, 1000);
        }
    }
})
.on('focus blur',function(){
    if(email.getData('valid') == true) {
        email.style('valid');
    } else {
        email.style('default');
    }
});

emailCheck.on("change", function(){
    var button = email.field.parents('div.form-container').children('a.next');
    if(  $(this).val() == "done") {
        var message = null;
        if(apiResponse.is_valid == true) {
            button.css('visibility','visible');
            email.style('valid');
            email.removeValidationError();

            if(apiResponse.did_you_mean == null) {
                phone.field.focus();
            } else {
                message = 'Did you mean ' + apiResponse.did_you_mean + '? <br/><span class="replace btn btn-danger" data-replace="'+apiResponse.did_you_mean+'"> Replace </span>  &nbsp; <span class="btn btn-success do-not-replace"> Keep </span>';
                email.setValidationError(message);
            }

        } else {
            email.style('error').setData('valid',false);
            if(apiResponse.did_you_mean == null) {
                message = "Invalid email address";
                email.setValidationError(message);

            } else {
                message = "Invalid email.  ";
                message += 'Did you mean ' + apiResponse.did_you_mean + '? <span class="replace btn btn-default" data-replace="'+apiResponse.did_you_mean+'"> Update </span>';
                $('html,body').animate({ scrollTop: 0 }, 'slow');
                email.setValidationError(message);
            }
        }
    }
}).triggerHandler('change');

email.field.on('focus, blur', function(e){
    if(validationObject.user_email) {
        email.style('valid');
    }
});

$(document).on('click', 'span.replace', function(){
    email.field.val(apiResponse.did_you_mean);
    email.style('valid');
    email.setData('valid', 1);
    $(this).parents('div.error_messages').css('display','none');

    var button = email.field.parents('div.form-container').children('a.next').css('visibility','hidden');

    setTimeout( function(){
        button.click(function(){
            phone.field.focus();
        });
    },500);
});

$(document).on('click', 'span.do-not-replace', function(){
    $(this).parents('div.error_messages').css('display','none');
    email.style('valid');
    email.setData('valid', 1);
    var button = email.field.parents('div.form-container').children('a.next').css('visibility','hidden');

    setTimeout( function(){
        button.click(function(){
            phone.field.focus();
        });
    },500);

});

phone.field
    .on('keyup', function () {
        var number = phone.field.val().replace(/\D/g, '');
        phone_user.field.val(number);
        var validationResponse = false;
        if (number.length < 10) {
            phone.style('default').setData('valid', false);

        } else {
            formFunctions.validatePhone(number);
        }
    })
    .on('blur', function(){
        if(phone_user.field.val().length < 10) {
            phone.style('error');
        }
    });

$(document).on('click', 'span.accept-number', function(){
    $('input.form-control').attr('readonly',true);
    $(this).parents('div.error_messages').css('visibility','hidden');
    phone.style('valid');
    phone.setData('valid', true);
    phone.loaderOnFinal();

    setTimeout( function(){
        formFunctions.finalPhoneValid();
    },500);

});

$(document).on('click', 'span.clear-number', function(){
    $(this).parents('div.error_messages').css('visibility','hidden');
    phone.style('default');
    phone.setData('valid', false);
    phone.field.val("").focus();
});

$('.privacy-policy-trigger').click(function(){
    $('#privacy-policy').modal('show');
});

$("#submit-form").click(function(e) {
    if(formFunctions.validator()) {
        formFunctions.submitForm();
    }
});

$("#" + $(".ui-state-active").attr('tabindex') + "_nav");

$(".tab-linker-next").click(function(){
    var $curr = $("#" + $(".ui-state-active").attr('tabindex') + "_nav");
    var $next = $("#" + $(".ui-state-active").data('name') + "_nav").siblings('span').first();
});

$("#ui-id-2").click(function(e){

});


$('input').on('keydown', function(e) {
    if (e.which == 13) {
        e.preventDefault();

        if($(this).attr('id') == 'user_first') {
            lastName.field.focus();
        } else if($(this).attr('id') == 'user_last') {
            userLocation.field.focus();
        } else if($(this).attr('id') == 'user_location') {
            email.field.focus();
        } else if($(this).attr('id') == 'user_email') {
            phone.field.focus();
        } else if($(this).attr('id') == 'user_phone_input') {
            if(formFunctions.validator()) {
                formFunctions.submitForm();
            }
        }
    }
});

$("div.form-row").on({
   hover: function() {
       $(this).css('background', 'red');
   }
});